/* src/app/components/item-selectable-article/item-selectable-article.component.scss */
.item-selectable-article {
  margin: 0 auto;
  flex-grow: 1;
  min-height: 100%;
  word-break: break-word;
  background: white;
  border: 2px solid white;
  border-radius: 5px;
  transition: border 200ms linear;
}
.item-selectable-article.selected {
  border: 2px solid var(--ion-color-primary);
}
.option-price {
  font-size: 12px;
  margin: auto;
  font-weight: bold;
  color: black;
}
.name {
  margin-top: 12px;
  font-size: 14px;
  width: 100%;
  font-weight: bold;
}
.item-selectable-article-image {
  margin: 0 auto;
  height: 100px;
}
app-quantity-selector {
  filter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.1));
}
.quantity-row {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  justify-content: center;
  --quantity-selector-border-width: 1.5px;
  --quantity-selector-height: 24px;
}
/*# sourceMappingURL=item-selectable-article.component.css.map */
